import { bus, axios, i18n, apiURL } from '../main'
import moment from "moment/moment";

export default {
    state: {
        mengen: [],
        mengenTotal: 0,
        verwerter: [],
        verwerterSelected: 0,
    },
    actions: {
        loadMengen: async function ({ state, commit, rootState }) {
            try {
                var mengen = await axios.get(apiURL + 'mengen.cfc?method=getMengen',
                    {
                        params: {
                            locale: i18n.locale,
                            verwerter: state.verwerterSelected,
                            betrieb: rootState.searchStore.searchValues.betriebSelected,
                            von: moment(rootState.searchStore.searchValues.von).format("YYYYMM"),
                            bis: moment(rootState.searchStore.searchValues.bis).format("YYYYMM"),
                        }
                    })
                await commit('setMengen', mengen.data)
                //bus.$emit('criteriaLoaded', 'Loaded criteria')
            }
            catch (e) {
                bus.$emit('error', 'Error loading quantities ... ' + JSON.stringify(e.message))
            }
        },
        loadVerwerter: async function ({ commit }) {
            try {
                var verwerter = await axios.get(apiURL + 'mengen.cfc?method=getVerwerter')
                await commit('setVerwerter', verwerter.data)
            }
            catch (e) {
                bus.$emit('error', 'Error loading buyers ... ' + JSON.stringify(e.message))
            }
        },
    },
    mutations: {
        setMengen: function (state, value) {
            state.mengen = value
            let total = 0
            for (let i = 0; i < value.length; i++) total += value[i].menge
            state.mengenTotal = total
        },
        setVerwerter: function (state, value) {
            state.verwerter = value
        },
        setVerwerterSelected: function (state, value) {
            state.verwerterSelected = value
        },
    }
}